<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>每刻冻结中列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main_list">
            <div class="flex">
                <div class="main_header_btns">
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_exec_log_detail"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'admin'">
                                <span v-if="scope.row.admin"> {{ scope.row.admin.name + '(' + scope.row.admin.code + ')' }}</span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetLineComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_exec_log_detail'
            },
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            budget_item_rid: '',
            postList1: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        if (this.postList.params) {
            this.row = 10;
        }
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.budget_item_rid) {
                        this.budget_item_rid = newValue.params.budget_item_rid;
                    }
                }
                this.getList(0); //获取列表
            },
            deep: true
        }
    },
    beforeMount() {
        this.budget_item_rid = this.postList.params.budget_item_rid;
        //详情内调用不用本地存储的params
        // if (!this.postList.params) {
        //     //列表页面调用 优先取本地存储
        //     var paramsList = JSON.parse(localStorage.getItem('paramsList'));
        //     if (paramsList['budgetSource_params']) {
        //         this.page = paramsList['budgetSource_params'].page;
        //         this.row = paramsList['budgetSource_params'].row;
        //     }
        // }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                budget_item_rid: this.budget_item_rid
            };
            // //当点击 或者触发回车事件保存参数
            // if (type == 1) {
            //     var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            //     newParamsList['budgetSource_params'] = params;
            //     localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            // }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .budgetItemFreezingLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            // if (res.data.current_page > res.data.last_page) {
                            //     var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                            //     newParamsList['budgetSource_params'].page = res.data.last_page;
                            //     localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                            //     this.page = res.data.last_page;
                            // }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            // if (!this.postList.params) {
            //     var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            //     if (newParamsList['budgetSource_params']) {
            //         newParamsList['budgetSource_params'].page = val;
            //         localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            //     } else {
            //         var params = {
            //             page: this.page,
            //             row: this.row,
            //             budget_item_rid: this.budget_item_rid
            //         };
            //         var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            //         newParamsList['budgetSource_params'] = params;
            //         localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            //     }
            // }
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            // if (!this.postList.params) {
            //     var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            //     if (newParamsList['budgetSource_params']) {
            //         newParamsList['budgetSource_params'].row = val;
            //         localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            //     } else {
            //         var params = {
            //             page: this.page,
            //             row: this.row,
            //             budget_item_rid: this.budget_item_rid
            //         };
            //         var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            //         newParamsList['budgetSource_params'] = params;
            //         localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            //     }
            // }
            this.getList(0);
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_exec_log_detail', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_exec_log_detail;
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>